import React, { useEffect, useMemo, useState } from "react";
import {
  Users,
  Star,
  MapPin,
  Phone,
  Mail,
  Globe,
  Check,
  X,
  Loader2,
  ZoomIn,
} from "lucide-react";
import { useNavigate } from "react-router-dom";
import RoomCarousel from "./RoomCarousel";
import Stimg1 from "../assets/StandardRoom/one.webp";
import Stimg2 from "../assets/StandardRoom/two.webp";
import Stimg3 from "../assets/StandardRoom/three.webp";
import Stimg4 from "../assets/StandardRoom/four.webp";
import Stimg5 from "../assets/StandardRoom/five.webp";
import Stimg6 from "../assets/StandardRoom/six.webp";
import Stimg7 from "../assets/StandardRoom/seven.webp";
import Stimg8 from "../assets/StandardRoom/eight.webp";
import Stimg9 from "../assets/StandardRoom/nine.webp";
import Stimg10 from "../assets/StandardRoom/ten.webp";
// er image
import erimg1 from "../assets/ExecutiveRoom/one.webp";
import erimg2 from "../assets/ExecutiveRoom/two.webp";
import erimg3 from "../assets/ExecutiveRoom/three.webp";
import erimg4 from "../assets/ExecutiveRoom/four.webp";
import erimg5 from "../assets/ExecutiveRoom/five.webp";
import erimg6 from "../assets/ExecutiveRoom/six.webp";
import erimg7 from "../assets/ExecutiveRoom/seven.webp";
import erimg8 from "../assets/ExecutiveRoom/eight.webp";
import erimg9 from "../assets/ExecutiveRoom/nine.webp";
import erimg10 from "../assets/ExecutiveRoom/ten.webp";

// sr
import srimg1 from "../assets/SuiteRoom/one.webp";
import srimg2 from "../assets/SuiteRoom/two.webp";
import srimg3 from "../assets/SuiteRoom/three.webp";
import srimg4 from "../assets/SuiteRoom/four.webp";
import srimg5 from "../assets/SuiteRoom/five.webp";
import srimg6 from "../assets/SuiteRoom/six.webp";
import srimg7 from "../assets/SuiteRoom/seven.webp";
import srimg8 from "../assets/SuiteRoom/eight.webp";
import HeroCarousel from "./HeroCarousel";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

function BookingPage({ handleDynamicRoutes }) {
  const [previewImage, setPreviewImage] = useState(null);

  useEffect(() => {
    localStorage.removeItem("adminRoute");
  }, []);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    roomType: "",
    occupancyType: "",
    checkIn: "",
    checkOut: "",
  });
  const navigate = useNavigate();
  const [errors, setErrors] = useState({});
  const [submittedData, setSubmittedData] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showBookingModal, setShowBookingModal] = useState(false);
  const [adminEmail, setAdminEmail] = useState("");
  const [adminPassword, setAdminPassword] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [selectedRoomForBooking, setSelectedRoomForBooking] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  // const [previewImage, setPreviewImage] = useState(null);

  const rooms = [
    {
      label: "Standard Room",
      value: "standard",
      nos: 8,
      singleRate: 1300,
      doubleRate: 1500,
      // Multiple images as an array
      images: [
        Stimg5,
        Stimg1,
        Stimg2,
        Stimg3,
        Stimg4,
        ,
        Stimg6,
        Stimg7,
        Stimg8,
        Stimg9,
        Stimg10,
      ],
      amenities: ["Free WiFi", "Air Conditioning", "TV", "Mini Fridge"],
      size: "250 sq ft",
    },
    {
      label: "Executive Room",
      value: "executive",
      nos: 2,
      singleRate: 1500,
      doubleRate: 1800,
      images: [
        erimg1,
        erimg2,
        erimg3,
        erimg4,
        erimg5,
        erimg6,
        erimg7,
        erimg8,
        erimg9,
        erimg10,
      ],
      amenities: [
        "Free WiFi",
        "Air Conditioning",
        "TV",
        "Work Desk",
        "Mini Bar",
      ],
      size: "350 sq ft",
    },
    {
      label: "Suite Room",
      value: "suite",
      nos: 1,
      singleRate: 2500,
      doubleRate: 2700,
      images: [srimg1, srimg2, srimg3, srimg4, srimg5, srimg6, srimg7, srimg8],
      amenities: [
        "Free WiFi",
        "Air Conditioning",
        "Smart TV",
        "Living Area",
        "Premium Minibar",
        "City View",
      ],
      size: "500 sq ft",
    },
  ];

  const validateForm = () => {
    const newErrors = {};
    if (!formData.name) newErrors.name = "Name is required";
    if (!formData.email) newErrors.email = "Email is required";
    else if (!/^\S+@\S+\.\S+$/.test(formData.email))
      newErrors.email = "Invalid email";
    if (!formData.phone) newErrors.phone = "Phone is required";
    else if (!/^[0-9()\s-]+$/.test(formData.phone))
      newErrors.phone = "Invalid phone";
    if (!formData.roomType) newErrors.roomType = "Room type is required";
    if (!formData.occupancyType)
      newErrors.occupancyType = "Occupancy is required";
    if (!formData.checkIn) newErrors.checkIn = "Check-in is required";
    if (!formData.checkOut) newErrors.checkOut = "Check-out is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setIsSubmitting(true);

    try {
      await fetch(
        "https://script.google.com/macros/s/AKfycbxb_aU-CSUOtaqjo2k26lKeiLbGDq8XW-I_TjfKrzCO2zgM1cQqNfP_gYuI8ektIC30/exec",
        {
          method: "POST",
          mode: "no-cors",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );

      setSubmittedData(formData);
      setShowBookingModal(false);
      setTimeout(() => {
        setFormData({
          name: "",
          email: "",
          phone: "",
          roomType: "",
          occupancyType: "",
          checkIn: "",
          checkOut: "",
        });
        setSubmittedData(null);
      }, 5000);
    } catch (error) {
      alert("Network error: " + error.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleAdminLogin = () => {
    if (adminEmail === "admin@gmail.com" && adminPassword === "12345") {
      alert("Login Successful!");

      const randomRoute = `admin-${Math.random().toString(36).substring(2, 8)}`;
      localStorage.setItem("isAdmin", "true");
      localStorage.setItem("adminRoute", randomRoute);
      handleDynamicRoutes(randomRoute); // instantly set parent route

      setShowModal(false);
      navigate(`/${randomRoute}`);
    } else {
      alert("Invalid Credentials");
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const handleRoomClick = (room) => {
    setSelectedRoomForBooking(room);
    setFormData((prev) => ({ ...prev, roomType: room.value }));
    setShowBookingModal(true);
  };

  const currentRoom = rooms.find((r) => r.value === formData.roomType);
  const displayedRate =
    currentRoom && formData.occupancyType
      ? formData.occupancyType === "single"
        ? currentRoom.singleRate
        : currentRoom.doubleRate
      : "";
  console.log(selectedRoomForBooking, "selectedRoomForBooking");
const filteredImages = useMemo(() => {
  return selectedRoomForBooking?.images?.filter(Boolean) || [];
}, [selectedRoomForBooking]);



useEffect(() => {
  if (filteredImages.length === 0) return;

  const interval = setInterval(() => {
    setCurrentIndex((prev) =>
      prev === filteredImages.length - 1 ? 0 : prev + 1
    );
  }, 3000);

  return () => clearInterval(interval);
}, [filteredImages]);




  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white shadow-sm sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 py-4 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-blue-600 rounded-lg flex items-center justify-center">
              <span className="text-white font-bold text-xl">K</span>
            </div>
            <div>
              <h1 className="text-2xl font-bold text-gray-900">
                Karuna Regent
              </h1>
              <div className="flex items-center gap-1 text-sm text-gray-600">
                <Star className="w-4 h-4 fill-yellow-400 text-yellow-400" />
                <Star className="w-4 h-4 fill-yellow-400 text-yellow-400" />
                <Star className="w-4 h-4 fill-yellow-400 text-yellow-400" />
                <Star className="w-4 h-4 fill-yellow-400 text-yellow-400" />
                <span className="ml-1">4.5 (324 reviews)</span>
              </div>
            </div>
          </div>
          <button
            onClick={() => setShowModal(true)}
            className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
          >
            Admin Login
          </button>
        </div>
      </header>

      {/* Hero Section */}
      {/* <div className="relative h-96 bg-gradient-to-r from-blue-600 to-blue-800">
        <img
          src="https://images.unsplash.com/photo-1542314831-068cd1dbfeeb?w=1600&q=80"
          alt="Hotel"
          className="w-full h-full object-cover opacity-40"
        />
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="text-center text-white">
            <h2 className="text-5xl font-bold mb-4">
              Welcome to Karuna Regent
            </h2>
            <p className="text-xl mb-2">
              Experience Comfort & Elegance in Chennai
            </p>
            <div className="flex items-center justify-center gap-2 text-sm">
              <MapPin className="w-4 h-4" />
              <span>Saligramam, Chennai, Tamil Nadu</span>
            </div>
          </div>
        </div>
      </div> */}
      <HeroCarousel />

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-4 py-8">
        {submittedData && (
          <div className="mb-6 bg-green-50 border border-green-200 rounded-lg p-4 flex items-center gap-3">
            <Check className="w-6 h-6 text-green-600" />
            <div>
              <h3 className="font-semibold text-green-900">
                Booking Confirmed!
              </h3>
              <p className="text-green-700">
                Thank you, {submittedData.name}! We've received your booking
                request.
              </p>
            </div>
          </div>
        )}

        <div className="grid lg:grid-cols-3 gap-8">
          {/* Left Column - Rooms */}
          <div className="lg:col-span-2 space-y-6">
            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                Available Rooms
              </h2>
              <p className="text-gray-600 mb-6">
                Choose from our selection of comfortable and well-appointed
                rooms
              </p>
            </div>

            {rooms.map((room) => (
              <div
                key={room.value}
                className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-lg transition-shadow"
              >
                <div className="md:flex">
                  {/* Carousel Section */}
                  <div className="md:w-1/3 relative group">
                    <RoomCarousel
                      images={room.images}
                      label={room.label}
                      onClick={() => handleRoomClick(room)}
                    />
                  </div>

                  {/* Room Details */}
                  <div className="md:w-2/3 p-6">
                    <div className="flex items-start justify-between mb-3">
                      <div>
                        <h3 className="text-xl font-bold text-gray-900">
                          {room.label}
                        </h3>
                        <p className="text-sm text-gray-600">
                          {room.size} • {room.nos} rooms available
                        </p>
                      </div>
                      <div className="text-right">
                        <div className="text-2xl font-bold text-blue-600">
                          ₹{room.singleRate}
                        </div>
                        <div className="text-xs text-gray-600">per night</div>
                      </div>
                    </div>

                    <div className="flex flex-wrap gap-213 mb-4">
                      {room.amenities.map((amenity, idx) => (
                        <span
                          key={idx}
                          className="px-3 py-1 bg-blue-50 text-blue-700 text-xs rounded-full"
                        >
                          {amenity}
                        </span>
                      ))}
                    </div>

                    <div className="flex items-center gap-4 text-sm text-gray-700 mb-4">
                      <div className="flex items-center gap-1">
                        <Users className="w-4 h-4" />
                        <span>Single: ₹{room.singleRate}</span>
                      </div>
                      <div className="flex items-center gap-1">
                        <Users className="w-4 h-4" />
                        <span>Double: ₹{room.doubleRate}</span>
                      </div>
                    </div>

                    <button
                      onClick={() => handleRoomClick(room)}
                      className="w-full md:w-auto px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-medium"
                    >
                      Book Now
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Right Column - Booking Form */}
          <div className="lg:col-span-1">
            <div className="bg-white rounded-xl shadow-md p-6 sticky top-24">
              <h3 className="text-xl font-bold text-gray-900 mb-4">
                Book Your Stay
              </h3>

              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Full Name
                  </label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="John Doe"
                    className={`w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${
                      errors.name ? "border-red-500" : "border-gray-300"
                    }`}
                  />
                  {errors.name && (
                    <p className="text-red-500 text-xs mt-1">{errors.name}</p>
                  )}
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Email
                  </label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="john@example.com"
                    className={`w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${
                      errors.email ? "border-red-500" : "border-gray-300"
                    }`}
                  />
                  {errors.email && (
                    <p className="text-red-500 text-xs mt-1">{errors.email}</p>
                  )}
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Phone Number
                  </label>
                  <input
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    placeholder="+91 98765 43210"
                    className={`w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${
                      errors.phone ? "border-red-500" : "border-gray-300"
                    }`}
                  />
                  {errors.phone && (
                    <p className="text-red-500 text-xs mt-1">{errors.phone}</p>
                  )}
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Room Type
                  </label>
                  <select
                    name="roomType"
                    value={formData.roomType}
                    onChange={handleChange}
                    className={`w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${
                      errors.roomType ? "border-red-500" : "border-gray-300"
                    }`}
                  >
                    <option value="">Select Room</option>
                    {rooms.map((room) => (
                      <option key={room.value} value={room.value}>
                        {room.label} ({room.nos} available)
                      </option>
                    ))}
                  </select>
                  {errors.roomType && (
                    <p className="text-red-500 text-xs mt-1">
                      {errors.roomType}
                    </p>
                  )}
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Occupancy
                  </label>
                  <select
                    name="occupancyType"
                    value={formData.occupancyType}
                    onChange={handleChange}
                    className={`w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${
                      errors.occupancyType
                        ? "border-red-500"
                        : "border-gray-300"
                    }`}
                  >
                    <option value="">Select Occupancy</option>
                    <option value="single">Single Occupancy</option>
                    <option value="double">Double Occupancy</option>
                  </select>
                  {errors.occupancyType && (
                    <p className="text-red-500 text-xs mt-1">
                      {errors.occupancyType}
                    </p>
                  )}
                </div>

                <div className="grid grid-cols-2 gap-3">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Check-in
                    </label>
                    <input
                      type="datetime-local"
                      name="checkIn"
                      value={formData.checkIn}
                      onChange={handleChange}
                      className={`w-full px-3 py-2 border rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${
                        errors.checkIn ? "border-red-500" : "border-gray-300"
                      }`}
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Check-out
                    </label>
                    <input
                      type="datetime-local"
                      name="checkOut"
                      value={formData.checkOut}
                      onChange={handleChange}
                      className={`w-full px-3 py-2 border rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${
                        errors.checkOut ? "border-red-500" : "border-gray-300"
                      }`}
                    />
                  </div>
                </div>

                {currentRoom && formData.occupancyType && (
                  <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
                    <div className="text-sm text-blue-900 mb-1">Total Rate</div>
                    <div className="text-2xl font-bold text-blue-600">
                      ₹{displayedRate}
                    </div>
                    <div className="text-xs text-blue-700">per night</div>
                  </div>
                )}

                <button
                  onClick={handleSubmit}
                  disabled={isSubmitting}
                  className="w-full bg-blue-600 text-white py-3 rounded-lg font-semibold hover:bg-blue-700 transition-colors disabled:bg-blue-400 disabled:cursor-not-allowed flex items-center justify-center gap-2"
                >
                  {isSubmitting ? (
                    <>
                      <Loader2 className="w-5 h-5 animate-spin" />
                      Processing...
                    </>
                  ) : (
                    "Confirm Booking"
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Hotel Info Section */}
        <div className="mt-12 bg-white rounded-xl shadow-md p-8">
          <h3 className="text-2xl font-bold text-gray-900 mb-6">
            About Karuna Regent
          </h3>
          <div className="grid md:grid-cols-2 gap-8">
            <div>
              <h4 className="font-semibold text-gray-900 mb-3">
                Location & Contact
              </h4>
              <div className="space-y-3 text-gray-700">
                <div className="flex items-start gap-3">
                  <MapPin className="w-5 h-5 text-blue-600 flex-shrink-0 mt-0.5" />
                  <span>
                    30, Gangappa Naidu Street, Opp. AVM Studios, Saligramam,
                    Chennai, Tamil Nadu 600093
                  </span>
                </div>
                <div className="flex items-center gap-3">
                  <Phone className="w-5 h-5 text-blue-600" />
                  <span>7200084488 | 044-42111203</span>
                </div>
                <div className="flex items-center gap-3">
                  <Mail className="w-5 h-5 text-blue-600" />
                  <span>reservations@karunaregent.com</span>
                </div>
                <div className="flex items-center gap-3">
                  <Globe className="w-5 h-5 text-blue-600" />
                  <a
                    href="https://www.karunaregent.com"
                    className="text-blue-600 hover:underline"
                  >
                    www.karunaregent.com
                  </a>
                </div>
              </div>
            </div>
            <div>
              <h4 className="font-semibold text-gray-900 mb-3">
                Check-in Information
              </h4>
              <div className="space-y-3 text-gray-700">
                {/* <div className="flex items-center gap-3">
                  <Clock className="w-5 h-5 text-blue-600" />
                  <span>Check-in: 2:00 PM | Check-out: 12:00 PM</span>
                </div> */}
                <div className="flex items-start gap-3">
                  <Check className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" />
                  <span>Free cancellation up to 24 hours before check-in</span>
                </div>
                <div className="flex items-start gap-3">
                  <Check className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" />
                  <span>Complimentary breakfast included</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Location Map */}
        <div className="mt-12 bg-white rounded-xl shadow-md overflow-hidden">
          <div className="p-6 border-b border-gray-200">
            <h3 className="text-2xl font-bold text-gray-900">Find Us Here</h3>
            <p className="text-gray-600 mt-1">
              Located conveniently in Saligramam, Chennai
            </p>
          </div>
          <div className="w-full h-96">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3886.9535607876845!2d80.20159731482204!3d13.038953090810757!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a5267a9affffffb%3A0x3e3e3e3e3e3e3e3e!2sGangappa%20Naidu%20St%2C%20Saligramam%2C%20Chennai%2C%20Tamil%20Nadu%20600093!5e0!3m2!1sen!2sin!4v1234567890123!5m2!1sen!2sin"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Karuna Regent Location"
            ></iframe>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-gray-900 text-gray-300 mt-16 py-8">
        <div className="max-w-7xl mx-auto px-4 text-center">
          <p>© 2025 Karuna Regent | All Rights Reserved</p>
        </div>
      </footer>

      {/* Admin Modal */}
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl shadow-xl max-w-md w-full p-6">
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-xl font-bold text-gray-900">Admin Login</h3>
              <button
                onClick={() => setShowModal(false)}
                className="text-gray-400 hover:text-gray-600"
              >
                <X className="w-6 h-6" />
              </button>
            </div>

            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Email
                </label>
                <input
                  type="email"
                  placeholder="admin@gmail.com"
                  value={adminEmail}
                  onChange={(e) => setAdminEmail(e.target.value)}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Password
                </label>
                <input
                  type="password"
                  placeholder="••••••"
                  value={adminPassword}
                  onChange={(e) => setAdminPassword(e.target.value)}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                />
              </div>

              <button
                onClick={handleAdminLogin}
                className="w-full bg-blue-600 text-white py-2 rounded-lg font-semibold hover:bg-blue-700 transition-colors"
              >
                Login
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Quick Booking Modal */}
      {showBookingModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4 overflow-y-auto">
          <div className="bg-white t-20 rounded-xl shadow-xl max-w-2xl w-full p-6 my-8" style={{height:'90vh',overflowY:"auto"}}>
            <div className="flex items-center justify-between mb-6">
              <div>
                <h3 className="text-2xl font-bold text-gray-900">
                  Book {selectedRoomForBooking?.label}
                </h3>
                <p className="text-gray-600">Complete your booking details</p>
              </div>
              <button
                onClick={() => setShowBookingModal(false)}
                className="text-gray-400 hover:text-gray-600"
              >
                <X className="w-6 h-6" />
              </button>
            </div>

            {selectedRoomForBooking && (
              <div className="mb-6 p-4 bg-blue-50 rounded-lg">
                <div className="relative w-full h-60 overflow-hidden rounded-xl">
                  {/* All images in one row */}
                  <div
                    className="flex transition-transform duration-700 ease-in-out"
                    style={{
                      transform: `translateX(-${currentIndex * 100}%)`,
                    }}
                  >
                    {filteredImages.map((img, i) => (
                      <img
                        key={i}
                        src={img}
                        onClick={() => setPreviewImage(img)}
                        className="w-full h-60 object-cover flex-shrink-0 cursor-pointer"
                      />
                    ))}
                  </div>

                  {/* Left Button */}
                  <button
                    className="absolute left-3 top-1/2 -translate-y-1/2 bg-black/50 text-white px-3 py-1 rounded-full text-lg"
                    onClick={() =>
                      setCurrentIndex(
                        currentIndex === 0
                          ? filteredImages.length - 1
                          : currentIndex - 1
                      )
                    }
                  >
                    ‹
                  </button>

                  {/* Right Button */}
                  <button
                    className="absolute right-3 top-1/2 -translate-y-1/2 bg-black/50 text-white px-3 py-1 rounded-full text-lg"
                    onClick={() =>
                      setCurrentIndex(
                        currentIndex === filteredImages.length - 1
                          ? 0
                          : currentIndex + 1
                      )
                    }
                  >
                    ›
                  </button>

                  {/* Dots */}
                  <div className="absolute bottom-2 w-full flex justify-center gap-2">
                    {filteredImages.map((_, i) => (
                      <div
                        key={i}
                        className={`w-2 h-2 rounded-full transition-all ${
                          currentIndex === i ? "bg-white" : "bg-white/40"
                        }`}
                      ></div>
                    ))}
                  </div>
                </div>
              </div>
            )}

            <div className="space-y-4">
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Full Name
                  </label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="John Doe"
                    className={`w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${
                      errors.name ? "border-red-500" : "border-gray-300"
                    }`}
                  />
                  {errors.name && (
                    <p className="text-red-500 text-xs mt-1">{errors.name}</p>
                  )}
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Phone Number
                  </label>
                  <input
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    placeholder="+91 98765 43210"
                    className={`w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${
                      errors.phone ? "border-red-500" : "border-gray-300"
                    }`}
                  />
                  {errors.phone && (
                    <p className="text-red-500 text-xs mt-1">{errors.phone}</p>
                  )}
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Email
                </label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="john@example.com"
                  className={`w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${
                    errors.email ? "border-red-500" : "border-gray-300"
                  }`}
                />
                {errors.email && (
                  <p className="text-red-500 text-xs mt-1">{errors.email}</p>
                )}
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Occupancy Type
                </label>
                <select
                  name="occupancyType"
                  value={formData.occupancyType}
                  onChange={handleChange}
                  className={`w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${
                    errors.occupancyType ? "border-red-500" : "border-gray-300"
                  }`}
                >
                  <option value="">Select Occupancy</option>
                  <option value="single">Single Occupancy</option>
                  <option value="double">Double Occupancy</option>
                </select>
                {errors.occupancyType && (
                  <p className="text-red-500 text-xs mt-1">
                    {errors.occupancyType}
                  </p>
                )}
              </div>

              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Check-in Date & Time
                  </label>
                  <input
                    type="datetime-local"
                    name="checkIn"
                    value={formData.checkIn}
                    onChange={handleChange}
                    className={`w-full px-3 py-2 border rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${
                      errors.checkIn ? "border-red-500" : "border-gray-300"
                    }`}
                  />
                  {errors.checkIn && (
                    <p className="text-red-500 text-xs mt-1">
                      {errors.checkIn}
                    </p>
                  )}
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Check-out Date & Time
                  </label>
                  <input
                    type="datetime-local"
                    name="checkOut"
                    value={formData.checkOut}
                    onChange={handleChange}
                    className={`w-full px-3 py-2 border rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${
                      errors.checkOut ? "border-red-500" : "border-gray-300"
                    }`}
                  />
                  {errors.checkOut && (
                    <p className="text-red-500 text-xs mt-1">
                      {errors.checkOut}
                    </p>
                  )}
                </div>
              </div>

              {currentRoom && formData.occupancyType && (
                <div className="bg-gradient-to-r from-blue-50 to-blue-100 border border-blue-200 rounded-lg p-4">
                  <div className="flex items-center justify-between">
                    <div>
                      <div className="text-sm text-blue-900 mb-1">
                        Total Rate
                      </div>
                      <div className="text-3xl font-bold text-blue-600">
                        ₹{displayedRate}
                      </div>
                      <div className="text-xs text-blue-700">
                        per night • {formData.occupancyType} occupancy
                      </div>
                    </div>
                    <Check className="w-12 h-12 text-blue-600" />
                  </div>
                </div>
              )}

              {/* <div className="flex gap-3 pt-4">
                <button
                  onClick={() => setShowBookingModal(false)}
                  className="flex-1 px-6 py-3 border border-gray-300 text-gray-700 rounded-lg font-semibold hover:bg-gray-50 transition-colors"
                >
                  Cancel
                </button>
                <button
                  onClick={handleSubmit}
                  disabled={isSubmitting}
                  className="flex-1 bg-blue-600 text-white py-3 rounded-lg font-semibold hover:bg-blue-700 transition-colors disabled:bg-blue-400 disabled:cursor-not-allowed flex items-center justify-center gap-2"
                >
                  {isSubmitting ? (
                    <>
                      <Loader2 className="w-5 h-5 animate-spin" />
                      Processing...
                    </>
                  ) : (
                    <>
                      <Check className="w-5 h-5" />
                      Confirm Booking
                    </>
                  )}
                </button>
              </div> */}
              <div className="flex flex-col sm:flex-row gap-3 pt-4">
                {/* Cancel */}
                <button
                  onClick={() => setShowBookingModal(false)}
                  className="w-full sm:w-auto flex-1 px-6 py-3 border border-gray-300 text-gray-700 rounded-lg font-semibold hover:bg-gray-50 transition-colors"
                >
                  Cancel
                </button>

                {/* Confirm */}
                <button
                  onClick={handleSubmit}
                  disabled={isSubmitting}
                  className="w-full sm:w-auto flex-1 bg-blue-600 text-white py-3 rounded-lg font-semibold hover:bg-blue-700 transition-colors disabled:bg-blue-400 disabled:cursor-not-allowed flex items-center justify-center gap-2"
                >
                  {isSubmitting ? (
                    <>
                      <Loader2 className="w-5 h-5 animate-spin" />
                      Processing...
                    </>
                  ) : (
                    <>
                      <Check className="w-5 h-5" />
                      Confirm Booking
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

    {previewImage && (
  <div
    className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50"
    onClick={() => setPreviewImage(null)}
  >
    {/* Close Button - Top Right */}
    <button
      onClick={(e) => {
        e.stopPropagation(); // prevent closing the popup when clicking the button
        setPreviewImage(null);
      }}
      className="absolute top-4 right-4 text-white bg-black/60 px-3 py-1 rounded-full text-xl font-bold hover:bg-black/80 transition"
    >
      ×
    </button>

    {/* Image */}
    <img
      src={previewImage}
      className="max-w-[90%] max-h-[90%] rounded-lg shadow-lg"
      alt="Preview"
    />
  </div>
)}

    </div>
  );
}

export default BookingPage;
